var _ = require('underscore');
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div>\n  <label class="strong small interactuable">\n    <div class="coloptions" href="#' +
__e( col_name ) +
'">\n      ' +
__e( col_name ) +
'\n      ';
 if (col_type == 'geometry') { ;
__p += '\n        <span class="tiny geo">GEO</span>\n      ';
 } ;
__p += '\n    </div>\n  </label>\n  <p class="small">\n    <a class="disabled">' +
__e( col_type ) +
'</a>\n  </p>\n</div>\n<p class="auto">' +
__e( col_name ) +
'_';
 if (col_type == 'geometry') { ;
__p += 'GEO';
 } ;
__p += '</p>\n';

}
return __p
}